var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.627,
    height: 23.023,
    viewBox: "0 0 27.627 23.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0060a9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.907,18.116a.862.862,0,0,1-.624-.267L6.24,11.518a.864.864,0,0,1,.624-1.46h3.166V3.439A1.441,1.441,0,0,1,11.468,2h2.878a1.441,1.441,0,0,1,1.439,1.439v6.619H18.95a.864.864,0,0,1,.624,1.46l-6.044,6.331A.862.862,0,0,1,12.907,18.116Z",
    transform: "translate(0.907 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.613,22.6H2.015A2.017,2.017,0,0,1,0,20.59v-.576A2.017,2.017,0,0,1,2.015,18h23.6a2.017,2.017,0,0,1,2.014,2.015v.576A2.017,2.017,0,0,1,25.613,22.6Z",
    transform: "translate(0 0.418)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.099fbb98cbd9a33c39425bc1dddb46a8.svg";
export { ForwardRef as ReactComponent };